import React, { useContext, useState } from "react"
import { useEffect } from "react";


const HeightContext = React.createContext(0);
const useHeight = () => {

    return useContext(HeightContext);
}

// create and export the AuthProvider - this is imported to the _app.js file
// and wrapped around the whole app, providing context to the whole app, and
// is called each time this specific context is accessed (updated or retrieved)
const HeightProvider = ({ height,  children }) => {
    const [state, dispatch] = useState(height)
    useEffect(() => {
        dispatch(height)
    }, [height])
    return (

            <HeightContext.Provider value={[state, dispatch]}>
                {children}
            </HeightContext.Provider>
        
    )
};

export { HeightProvider, useHeight };